<template>
  <el-drawer
    title="图片列表"
    :visible.sync="drawer"
    :direction="direction"
    :with-header="false"
    :before-close="handleClose"
  >
    <div class="drawer_view">
      <div style="height:50px;padding-left:20px;">图片列表</div>
      <el-row :gutter="30" class="images_view">
        <el-col :span="12" v-for="(value,index) in tableData" :key="index">
          <div class="item">
            <div class="title">{{value.name}}</div>
            <img :src="value.path" class="image" />
            <div>
              <el-button type="text" class="button" @click="onHandle(value)">选择</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20]"
        :page-size="paginate"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagecount"
      ></el-pagination>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: "hots-edit",
  data() {
    return {
      drawer: false,
      direction: "rtl",
      tableData: [],
      paginate: 10,
      pagecount: 0,
      currentPage: 1,
      items: [
        { name: "名称", id: "name" },
        { name: "图片", id: "path" }
      ],
      selected: []
    };
  },
  methods: {
    show() {
      this.drawer = true;
      this.currentPage = 1;
      this.getData();

    },
    getData(page = 1, size = this.paginate) {
      var self = this;
      this.$http.get("/admin/image", { page: page, size: size }).then(res => {
        let { total } = res.data;
        self.pagecount = total;
        let table = res.data.data;
        self.tableData = table;
      });
    },

    onHandle(value) {
      this.$emit("selected", value);
      this.drawer = false;
    },
    handleClose() {
      this.drawer = false;
    },
    handleCurrentChange(value) {
      console.log("value", value);
      this.currentPage = value;
      this.getData(this.currentPage, this.paginate);
    },
    handleSizeChange(size) {
      this.paginate = size;
      this.getData(this.currentPage, this.paginate);
    }
  }
};
</script>

<style scoped lang="less">
.drawer_view {
  // overflow: scroll;
  height:100vh;
  padding:10px;
  box-sizing: border-box;
  .images_view{
    height: calc(100vh - 100px);
    overflow: scroll;
    .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border:1px solid #ddd;
    margin-bottom:10px;
    border-radius: 5px;
    background: #ddd;
    .image {
      height: 100px;
    }
  }
  }
  
}
</style>